import { FounderItem, FounderSlot, FoundersSelection } from '@/models/founder-item.model';
import { effect, Injectable, signal } from '@angular/core';
import { tap } from 'rxjs';
import { FoundersService } from '../api/founders.service';
import { OfficesService } from '../api/franchises.service';

@Injectable({
  providedIn: 'root'
})
export class FoundersSlotsService {
slots = signal<FounderSlot[]>([]);
lists = signal<FounderItem[]>([]);

selectedList = signal<FounderItem[] | null>(null);

  constructor(
    private foundersService: FoundersService,
    private officesService: OfficesService,
  ) {
    effect(() => {
      const office = this.officesService.selectedOffice();
      console.log('office changed', office);
      if(office) {
        console.log('setting list by fid', office.FID);
        this.setListByFID(office.FID);
      }
    }, {allowSignalWrites: true});
   }

  populateSlots() {
    this.foundersService.getSlots().subscribe((res: any) => {
      this.slots.set(res);
      console.log('populateSlots', res);
    });
  }

  populateLists() {
    this.foundersService.getLists().subscribe((res: any) => {
      this.lists.set(res);
      this.selectedList.set(res[0]);
      console.log(this.lists());
    });
  }

  saveList(list: FoundersSelection[]) {
    return this.foundersService.saveList(list).pipe(
      tap({
        next: (res: any) => console.log('list saved', res),
        error: (err: any) => console.error('Error saving list:', err)
      })
    );
  }

  setListByFID(FID: number) {
    console.log('setting list by fid in function', FID);
    const list = this.lists().filter(item => item.FID === FID);
    this.selectedList.set(list);
    console.log('selected list', this.selectedList());
  }

}
